<template>
  <div>
    <v-layout row wrap>
      <v-flex grow>
        <h2 class="headline pb-3">Tenant</h2>
      </v-flex>
      <v-flex shrink>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              flat
              icon
              color="primary"
              @click.stop="saveHandler()"
              v-on="on"
            >
              <v-icon class="mr-1">save</v-icon>
            </v-btn>
          </template>
          <span>Save tenant details</span>
        </v-tooltip>
      </v-flex>
    </v-layout>
    <v-form ref="leaseTenant" v-model="valid" lazy-validation>
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex ms4>
            <v-text-field
              v-model="tenant.tenant_name"
              label="Given Name"
              required
              :rules="[v => !!v || '']"
            ></v-text-field>
          </v-flex>
          <v-flex ms4>
            <v-text-field
              v-model="tenant.tenant_email"
              label="Email"
              required
              :rules="[
                v => !!v || '',
                v => /.+@.+/.test(v) || 'E-mail must be valid'
              ]"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex ms4>
            <v-text-field
              v-model="tenant.tenant_phone"
              label="Phone"
              required
              :rules="[v => !!v || '']"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex ms4>
            <v-flex
              v-for="file in tenant.files"
              :key="file.id"
              xs12
            >
              <v-chip
                outline
                :close="true"
                class="width--auto"
                @input="
                  deleteFile({
                    id: file.id,
                    tenantId: tenant.id
                  })
                "
              >
                <v-avatar>
                  <v-icon>attach_file</v-icon>
                </v-avatar>
                <a :href="getFileUrl(file.url)" target="new" class="no--underline">
                  {{ file.name.substring(0, 20) }}
                </a>
              </v-chip>
            </v-flex>
          </v-flex>
          <v-flex ms4 class="text-xs-right">
            <v-btn
              v-if="tenant.id"
              color="primary"
              class="ma-0"
              @click.stop.prevent="initUpload()"
            >
              Add Files
            </v-btn>
            <input
              v-show="false"
              id=""
              ref="tenantAttachment"
              type="file"
              @change="upload($event)"
            />
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
    <!-- <TenantPanel></TenantPanel> -->
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import config from '@/config'
import TenantPanel from '@/components/houselist/details/TenantPanel'

export default {
  name: 'LeaseTenants',
  components: { TenantPanel },
  data() {
    return {
      valid: true
    }
  },
  computed: {
    ...mapGetters({
      lease: 'HouseList/Lease/getLease'
    }),
    tenant() {
      const tenant = this.$store.getters['HouseList/Lease/getTenant']

      if (Object.keys(tenant).length > 0) {
        return tenant
      } else {
        return {
          id: '',
          tenant_name: '',
          tenant_email: '',
          tenant_phone: ''
        }
      }
    }
  },
  methods: {
    ...mapActions({
      uploadFile: 'HouseList/Lease/uploadFile',
      deleteFile: 'HouseList/Lease/deleteFile',
      saveTenant: 'HouseList/Lease/saveTenants'
    }),
    initUpload() {
      this.$refs.tenantAttachment.click()
    },
    upload(event) {
      if (event.target.files.length > 0) {
        this.uploadFile({
          file: event.target.files[0],
          tenantId: this.tenant.id,
          houseId: parseInt(this.$route.params.houseId),
          leaseId: parseInt(this.$route.params.id)
        })
      }
    },
    getFileUrl(path) {
      return config.apiBaseUrl + path.substring(1)
    },
    saveHandler() {
      if (this.$refs.leaseTenant.validate()) {
        const tenant = {
          tenant_name: this.tenant.tenant_name,
          tenant_email: this.tenant.tenant_email,
          tenant_phone: this.tenant.tenant_phone,
          id: this.tenant.id
        }

        this.saveTenant({
          leaseId: this.$route.params.id,
          tenant: tenant
        })
      }
    }
  }
}
</script>
